exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-archivum-index-js": () => import("./../../../src/pages/archivum/index.js" /* webpackChunkName: "component---src-pages-archivum-index-js" */),
  "component---src-pages-archivum-js": () => import("./../../../src/pages/archivum/[...].js" /* webpackChunkName: "component---src-pages-archivum-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

